<!--电话会议-->
<template>
  <!--内容-->
  <div class="content_width_box">
    <!--网络直播-->
    <div class="content_title">
      <div class="title_left_h2">{{ $t('investor.telMeeting.webcast') }}</div>
    </div>
    <div class="webcast_list_box">
      <div class="webcast_list" v-for="(item, index) in webcastList" :key="index" @click="openWebcast(item.msgUrl||item.linkUrl)">
        <div class="webcast_date">{{ item.createDate }}</div>
        <div class="webcast_content">
          <div class="webcast_title">{{ isEn ? (item.enTitle || item.title) : item.title }}</div>
          <div class="webcast_right">{{ $t('investor.telMeeting.webcast') }}</div>
        </div>
      </div>
    </div>
    <!--投资者活动-->
    <div class="content_title">
      <div class="title_left_h2">{{ $t('investor.telMeeting.title') }}</div>
    </div>
    <div class="select_box">
      <multiselect v-model="yearSelected" 
        :options="['全部年份',...investorEventYearList]" 
        :searchable="false" :close-on-select="true" :show-labels="false" :placeholder="$t('investor.report.yearPlaceholder')"></multiselect>
    </div>
    
    <YearsTitleListView :messageList="investorEventList" :perPage="investorEventPerPage" detailRouter="investorEventDetail" :yearSelected="yearSelected"></YearsTitleListView>
  </div>  
</template>
<script>

import YearsTitleListView from '../../titleNews/YearsTitleListView'
import UtilEvent from '../../utils/UtilEvent.js'
  export default {
    name: 'investorTelMeeting',
    components:{UtilEvent,YearsTitleListView},
    props: ['telMeetingList'],
    created(){
        
    },
    data () {
      return {
        yearSelected:'全部年份',
        investorEventData: null,
        investorEventList: [],
        investorEventPerPage: 12,
        investorEventYearList: []
      }
    },
    computed:{
      isEn() {
        return this.$i18n.locale === 'en';
      },
      webcastList() {
        if (!this.telMeetingList || !this.telMeetingList.list) return [];
        return this.telMeetingList.list.slice(0, 5);
      }
    },
    methods:{
      openWebcast(url) {
        if (url) window.open(url, '_blank');
      },
      loadInvestorEventData() {
        new UtilEvent().getInvestorEventData(this);
      },
      reloadData(){
        // 语言切换时重新加载投资者活动数据
        this.loadInvestorEventData();
      }
    },
    watch:{
      investorEventData(val) {
        if (val) {
          this.investorEventYearList = val.yearList || [];
          this.investorEventPerPage = val.perPage || 12;
          this.investorEventList = val.list || [];
        }
      }
    },
    mounted(){
      this.loadInvestorEventData();
    },
   
  }
  </script>
